import React, { useState } from "react";
import TopNavigation from "../../../components/TopNavigation";
import InvitMembersPage from "../InvitMembers";
import DatePicker from "react-datepicker";
import { Base } from "../../../components/RootLayout";
import { Row, Col } from "react-bootstrap";
import { reminderBodyData, reminderFooterData } from "../data";
import { CustomDialog } from "../../../components/DialogCollection";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import "./style.scss";

const AddReminder = (props) => {
  const navigate = useNavigate();
  const { postReminder } = props;
  const [payload, setPayload] = useState({
    organization: 20,
    name: "",
    description: "",
    members: [],
    when: moment().toDate(),
    start: moment().toDate(),
    end: moment().toDate(),
    every: 1,
  });
  const [isInvitMember, setIsInvitMember] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleCloseAlert = () => {
    setShowAlert(false);
    if (alertMessage === "Add Reminder Success") {
      setAlertMessage("");
      navigate(PageRoutes.calendar);
    } else {
      setAlertMessage("");
    }
  };

  const handleChangeInput = (e) => {
    let { name, value } = e.target;
    setPayload((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeDate = (date, type) => {
    setPayload((prevState) => ({
      ...prevState,
      [type]: date,
    }));
  };

  const handleDeleteInvitedMembers = (idx) => {
    let deleteResult = [...payload.members];
    deleteResult.splice(idx, 1);
    setPayload((prevState) => ({
      ...prevState,
      members: deleteResult,
    }));
  };

  const handleAddReminder = async () => {
    if (!payload.name) {
      setAlertMessage("Title name is mandatory");
      setShowAlert(true);
    } else if (!payload.description) {
      setAlertMessage("Description is mandatory");
      setShowAlert(true);
    } else {
      let members = payload.members.map((a) => a.pk);
      let postData = {
        organization: payload.organization,
        name: payload.name,
        start: `${moment(payload.start).format("YYYY-MM-DDTHH:mm:ss")}`,
        members: members,
        description: payload.description,
        end: `${moment(payload.end).format("YYYY-MM-DDTHH:mm:ss")}`,
        when: moment(payload.when).format("HH:mm:ss"),
        every: payload.every,
      };

      const { status, message } = await postReminder(postData);
      if (status == 200) {
        setShowAlert(true);
        setAlertMessage("Add Reminder Success");
      } else {
        setShowAlert(true);
        setAlertMessage(message?.end?.[0]);
      }
    }
  };

  const p = {
    setIsInvitMember,
    payload,
    setPayload,
  };

  if (isInvitMember) {
    return <InvitMembersPage {...p} />;
  } else {
    return (
      <Base>
        <TopNavigation
          titlePage="Add Reminder"
          toPath={-1}
          setBorder={true}
          showRightIcon={false}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
          showRightText={true}
          rightText={"Add"}
          onRightNavClicked={handleAddReminder}
          rightTextClassname={"text-top-right"}
        />
        <div className="calendar-add-reminder-wrapper">
          <div className="greyspace" />
          <div className="title-wrapper">
            <input
              type="text"
              name="name"
              onChange={handleChangeInput}
              value={payload.name}
              placeholder="Title"
            />
          </div>
          <div className="greyspace" />
          <div className="body-wrapper">
            {reminderBodyData.map((data, idx) => (
              <div key={idx}>
                <Row className="content">
                  <Col xs={5} sm={5} md={5}>
                    <span>{data.label}</span>
                  </Col>
                  <Col xs={7} sm={7} md={7} className="right">
                    {idx === 0 || idx === 1 ? (
                      <div className="datepicker-wrapper">
                        <DatePicker
                          minDate={moment().toDate()}
                          selected={idx === 0 ? payload.start : payload.end}
                          onChange={
                            idx === 0
                              ? (date) => handleChangeDate(date, "start")
                              : (date) => handleChangeDate(date, "end")
                          }
                          showTimeSelect
                          timeIntervals={1}
                          dateFormat="d MMM yyyy, h:mm aa"
                        />
                      </div>
                    ) : idx === 2 ? (
                      <div className="remind-every-wrapper">
                        <input
                          type="number"
                          name="every"
                          onChange={handleChangeInput}
                          value={payload.every}
                        />
                        <span className="text">{data.value}</span>
                      </div>
                    ) : (
                      <div className="remind-when-wrapper">
                        <DatePicker
                          selected={payload.when}
                          onChange={(date) => handleChangeDate(date, "when")}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={1}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                <div className="line" />
              </div>
            ))}
          </div>
          <div className="greyspace" />
          <div className="footer-wrapper">
            {reminderFooterData.map((data, idx) => (
              <div key={idx}>
                <div className="content">
                  <div>{data.label}</div>
                  {idx === 0 ? (
                    <input
                      type="text"
                      name="description"
                      onChange={handleChangeInput}
                      value={payload.description}
                      placeholder={data.value}
                    />
                  ) : (
                    <div onClick={() => setIsInvitMember(true)}>
                      <span className="invit">{data.value}</span>
                    </div>
                  )}
                </div>
                <div className="line" />
              </div>
            ))}
            {payload.members &&
              payload.members.map((data, idx) => (
                <div className="invited-members" key={idx}>
                  <span className="text">
                    {data.first_name} {data.last_name}, {data.email}
                  </span>
                  <img
                    src={Assets.iconCalendarAddReminder}
                    alt="logo_image"
                    onClick={() => handleDeleteInvitedMembers(idx)}
                  />
                </div>
              ))}
          </div>
          <CustomDialog
            show={showAlert}
            title="Info"
            onHide={handleCloseAlert}
            buttonText="OK"
            content={<span>{alertMessage}</span>}
          />
        </div>
      </Base>
    );
  }
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  postReminder: dispatch.CalendarSM.postReminder,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReminder);
